import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  ClientDropdownProps,
  ClientDropdownState,
  ProgramDropdownProps,
} from '../types/clientDropdown.types'
import { noop } from 'lodash'

const initialState: ClientDropdownState = {
  clientDropdown: {
    isVisible: false,
    onChange: noop,
    isGlobalVisible: true,
    onOptionChange: noop,
  },
  programDropdown: { isVisible: false },
}
const clientDropdownSlice = createSlice({
  name: 'clientDropdown',
  initialState: initialState,
  reducers: {
    setClientDropdown: (
      state: ClientDropdownState,
      action: PayloadAction<ClientDropdownProps>
    ) => {
      state.clientDropdown = action.payload
    },
    setProgramDropdown: (
      state: ClientDropdownState,
      action: PayloadAction<ProgramDropdownProps>
    ) => {
      state.programDropdown = action.payload
    },
  },
})
export const { setClientDropdown, setProgramDropdown } =
  clientDropdownSlice.actions
export default clientDropdownSlice.reducer
